function Loading(){
    return <div className="box">
        <div className="loader"></div>
    </div>
}

export default Loading;